var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99841 12.9961C9.90813 12.9961 9.82536 12.9805 9.75008 12.9492C9.67494 12.918 9.60376 12.8665 9.53654 12.7948L5.55049 8.80859C5.41619 8.67901 5.35195 8.52276 5.35779 8.33984C5.36362 8.15707 5.43362 8.002 5.56779 7.87464C5.70209 7.74727 5.85897 7.68359 6.03841 7.68359C6.21772 7.68359 6.37105 7.74727 6.49841 7.87464L9.99841 11.3886L13.5124 7.87464C13.6396 7.74727 13.7906 7.68595 13.9655 7.69068C14.1402 7.69526 14.2947 7.76123 14.429 7.88859C14.5632 8.01582 14.6309 8.17089 14.6322 8.3538C14.6333 8.53672 14.569 8.69297 14.4395 8.82255L10.4672 12.7948C10.3954 12.8665 10.3219 12.918 10.2467 12.9492C10.1715 12.9805 10.0887 12.9961 9.99841 12.9961Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.19438c7586194515d4735383a8d9a8c8.svg";
export { ForwardRef as ReactComponent };